// 공통 에러 처리 유틸리티

export interface ErrorInfo {
  message: string;
  type: 'error' | 'warning' | 'info';
  action?: string;
}

export const getAuthErrorMessage = (errorCode: string): ErrorInfo => {
  switch (errorCode) {
    case 'auth/user-not-found':
      return {
        message: '해당 이메일로 가입된 계정이 없습니다.',
        type: 'error',
        action: '회원가입을 진행해주세요.'
      };
    
    case 'auth/wrong-password':
      return {
        message: '비밀번호가 올바르지 않습니다.',
        type: 'error',
        action: '비밀번호를 다시 확인해주세요.'
      };
    
    case 'auth/email-already-in-use':
      return {
        message: '이미 사용 중인 이메일입니다.',
        type: 'warning',
        action: '다른 이메일을 사용하거나 로그인을 시도해주세요.'
      };
    
    case 'auth/weak-password':
      return {
        message: '비밀번호가 너무 약합니다.',
        type: 'warning',
        action: '최소 6자 이상의 비밀번호를 설정해주세요.'
      };
    
    case 'auth/invalid-email':
      return {
        message: '유효하지 않은 이메일 형식입니다.',
        type: 'error',
        action: '올바른 이메일 주소를 입력해주세요.'
      };
    
    case 'auth/user-disabled':
      return {
        message: '비활성화된 계정입니다.',
        type: 'error',
        action: '고객센터에 문의해주세요.'
      };
    
    case 'auth/too-many-requests':
      return {
        message: '너무 많은 요청이 발생했습니다.',
        type: 'warning',
        action: '잠시 후 다시 시도해주세요.'
      };
    
    case 'auth/network-request-failed':
      return {
        message: '네트워크 연결을 확인해주세요.',
        type: 'error',
        action: '인터넷 연결 상태를 확인하고 다시 시도해주세요.'
      };
    
    case 'auth/cancelled-popup-request':
      return {
        message: '로그인이 취소되었습니다.',
        type: 'info'
      };
    
    case 'auth/popup-closed-by-user':
      return {
        message: '로그인 창이 닫혔습니다.',
        type: 'info'
      };
    
    case 'auth/unauthorized-domain':
      return {
        message: '허가되지 않은 도메인입니다.',
        type: 'error',
        action: '관리자에게 문의해주세요.'
      };
    
    default:
      return {
        message: '로그인 중 오류가 발생했습니다.',
        type: 'error',
        action: '다시 시도해주세요.'
      };
  }
};

export const getKakaoErrorMessage = (error: any): ErrorInfo => {
  if (error.message?.includes('이메일')) {
    return {
      message: '카카오 계정의 이메일 정보에 접근할 수 없습니다.',
      type: 'warning',
      action: '카카오 계정 설정에서 이메일 제공 동의를 확인해주세요.'
    };
  }
  
  if (error.response?.status === 401) {
    return {
      message: '카카오 인증이 만료되었습니다.',
      type: 'warning',
      action: '다시 로그인해주세요.'
    };
  }
  
  if (error.response?.status >= 500) {
    return {
      message: '카카오 서버에 일시적인 문제가 발생했습니다.',
      type: 'error',
      action: '잠시 후 다시 시도해주세요.'
    };
  }
  
  if (error.code) {
    return getAuthErrorMessage(error.code);
  }
  
  return {
    message: '카카오 로그인 중 오류가 발생했습니다.',
    type: 'error',
    action: '다시 시도해주세요.'
  };
};

export const logError = (context: string, error: any) => {
  console.error(`[${context}] Error:`, {
    message: error.message,
    code: error.code,
    stack: error.stack,
    timestamp: new Date().toISOString()
  });
}; 